import * as Sentry from "@sentry/browser";
Sentry.init({
    dsn: process.env.MIX_SENTRY_DSN,
    environment: process.env.MIX_APP_ENV,
    ignoreErrors: [
        "_AutofillCallbackHandler",
        "_pcmBridgeCallbackHandler",
    ]
});

const autoComplete = require('@tarekraafat/autocomplete.js')

import loadReCaptchaScript  from './recaptcha.js'

// load specific lodash function (to avoid lo load all the lib)
import flatten from 'lodash/flatten'
import toArray from 'lodash/toArray'

require('./bootstrap')
require('country-select-js/build/js/countrySelect.min')
require('./lib/card-selector')
require('./lib/redirector')
require('./lib/list-filter')

$(function () {
    courseStickyManagement()
})

// init main navbar sticky
$('#sponsors').waypoint({
    handler: direction => {
        $('#main-navbar').toggleClass('sticked', direction === 'down')
    }
})

// Bootstrap components setup
$(function () {
    $('[data-toggle="popover"]').popover({
        trigger: 'focus'
    })
    $('[data-toggle="tooltip"]').tooltip()
})

// init go-top link
$(function () {
    const $goTop = $('#go-top')

    if ($goTop.length !== 1) {
        return
    }
    const $win = $(window)
    let winHeight = $win.height()
    $win.on("scroll", function () {
        $goTop.toggleClass('d-none', $win.scrollTop() < (winHeight / 2))
    }).on("resize", function () { // If the user resizes the window
        winHeight = $(window).height(); // you'll need the new height value
    })
})

$('#navbarDiscoverMenuLink').parent('.dropdown').on('shown.bs.dropdown', ev => {
    $(ev.currentTarget).find('input').focus()
})

window.config_sliders = function () {
    $('[data-toggle="slider"]').each(function () {

        const getData = (key, def) => $(this).data('slider-' + key) === undefined ? def : $(this).data('slider-' + key);

        var responsive = getData('responsive', true) ? {
            640: {items: 4, edgePadding: 80},
            950: {items: 5, edgePadding: 80},
            1200: {items: 6, edgePadding: 80},
            1600: {items: 7, edgePadding: 140}
        } : {
            640: {items: 5},
            950: {items: 6},
            1200: {items: 8},
            1600: {items: 10}
        }

        if (getData('responsive') === false) {
            responsive = null
        }

        if (getData('custom-responsive')) {
            responsive = getData('custom-responsive')
        }

        if (getData('tall')) {
            responsive = {
                300: {items: 1.05, edgePadding: 10},
                840: {items: 1.35, edgePadding: 20},
                950: {items: 2.05, edgePadding: 40},
                1200: {items: 2.35, edgePadding: 40},
                1500: {items: 3.05, edgePadding: 40},
                2000: {items: 4.05, edgePadding: 40},
                3000: {items: 5.05, edgePadding: 20},
            }
        }

        const config = {
            controls: getData('controls', true),
            autoWidth: getData('auto-width', false),
            autoplay: getData('autoplay', false),
            autoplayButtonOutput: false,
            autoplayTimeout: getData('autoplay-timeout', 5000),
            container: this,
            controlsContainer: getData('controls', true) ? $(this).prev('.sliderControlsContainer').get(0) : false,
            items: getData('items', 1.4),
            edgePadding: getData('edge-padding', 10),
            slideBy: 1,
            lazyload: true,
            mouseDrag: true,
            nav: getData('nav', false),
            navContainer: getData('nav', false) ? $(this).next('.sliderNavContainer').get(0) : false,
            gutter: getData('gutter', 15),
            loop: getData('loop', true),
            fixedWidth: getData('fixed-width', 280),
            freezable: getData('freezable', false),
            responsive: responsive,
            preventScrollOnTouch: 'auto'
        }

        var slider = tns(config);

        // nascondo o meno le frecce di navigazione se arrivo all'inizio o alla fine della sequenza
        slider && slider.events.on('indexChanged', function (info, event) {
            $(info.prevButton).find('button').toggle(info.index !== 0);
            $(info.nextButton).find('button').toggle(info.index + info.items !== info.slideItems.length);
        });
    });
}

config_sliders()

// init counters
$('.counter').each(function () {
    var countUp = new CountUp(this, $(this).data('count'), {
        startVal: 0,
        decimalPlaces: 0,
        duration: 2,
        separator: '.',
        prefix: '+'
    })
    countUp.start()
})

const loadLazyPanelContent = function ($panel, url, scrollOnTop = false, callback = null) {
    $panel = $($panel)
    if ($panel.data('url') === url && $panel.data('loaded')) {
        return;
    }
    $panel.fadeTo(0, 0.4, function () {
        const urlAndWrapper = [url, '.lazy-panel', '> *'].join(' ')
        $panel.load(urlAndWrapper, function () {
            $panel.data('loaded', true)
            $panel.fadeTo('fast', 1, function () {
                scrollOnTop && $('html, body').animate({
                    scrollTop: $panel.offset().top - 140
                })
                callback && callback($panel)
            })
        })
    })
}

$(function () {
    $('.lazy-panel').each(function () {
        const $panel = $(this)
        if ($panel.hasClass('show')) {
            new Waypoint.Inview({
                element: $panel.get(0),
                enter: () => {
                    if (!$panel.data('loading')) {
                        $panel.data('loading', 1)
                        loadLazyPanelContent($panel, $panel.data('url'))
                    }
                }
            })
        } else {
            $('[data-bs-toggle="tab"][href="#' + $panel.attr('id') + '"]').one('shown.bs.tab', function () {
                loadLazyPanelContent($panel, $panel.data('url'))
            })
        }
    })
})

$('.lazy-panel').on('click', '.pagination a, a[data-pagination], button[data-pagination]', function (e) {
    e.preventDefault()
    const $this = $(e.currentTarget)
    const url = e.currentTarget.tag === 'a' ? e.currentTarget.href : $(e.currentTarget).data('url')
    if ($this.data('pagination') === 'append') {
        const newContainer = $("<div>...in caricamento</div>")
        newContainer.insertAfter($this.hide())
        loadLazyPanelContent(newContainer, url, false)
    } else {
        loadLazyPanelContent(e.delegateTarget, url, true)
    }
})

$(document)
    .on('click', '.readmore [data-toggle="readmore"]', function (e) {
        e.preventDefault()
        const readMore = $(e.currentTarget).parent()
        readMore.prev('.readmore--end').hide()
        readMore.hide()
        readMore.nextAll('.d-none').removeClass('d-none')
    })
    .on('click', '.readmore [data-toggle="readless"]', function (e) {
        e.preventDefault()
        const readLess = $(e.currentTarget).parent()
        readLess.prevAll().show()
        readLess.addClass('d-none')
        readLess.prev('.readmore--more').addClass('d-none')
    })

var hash = window.location.hash;
var $tabsElement = $('ul.nav-tabs a[href="' + hash + '"]');
(hash && $tabsElement.length) && $tabsElement.tab('show');

$('form').submit(function (event) {
    var $form = $(this)
    if ($form.hasClass('needs-login')) {
        event.preventDefault()
        $('#access-modal').modal('show', $form)
    }
})

$('#activate-modal').on('show.bs.modal', function (event) {
    const $related = $(event.relatedTarget) // Button that triggered the modal
    const course = $related.data('title')
    const url = $related.data('url')
    const productId = $related.data('product-id')
    $(this).find('.course-title').html(course)
    $(this).find('form[action="#"]').attr('action', url)
    $(this).find('input[name="product_id"]').val(productId)
})

$('#access-modal').on('show.bs.modal', function (event) {
    var related = $(event.relatedTarget) // Button that triggered the modal
    var relatedTag = related.prop('tagName').toLowerCase()
    var title = related.data('title') || ''
    var redirect
    if (relatedTag === 'a') {
        redirect = related.attr('href') || ''
    } else if (relatedTag === 'button' || relatedTag === 'input' || relatedTag === 'select') {
        redirect = related.closest('form')
        if (redirect.length === 0) {
            redirect = undefined
        }
    } else if (relatedTag === 'form') {
        redirect = related
    }
    var modal = $(this)
    modal.find('.modal-title').text(title)
    modal.data('redirect', redirect)
    loadReCaptchaScript()
})

$(document).ready(function () {
    if ($('#form-signin').length > 0) {
        loadReCaptchaScript()
    }
})
$('#form-signin').submit(function (e) {
    e.preventDefault();
    var $this = $(this);
    var $modal = $('#access-modal');
    var $loader = $modal.find('.modal-loader');
    var clearError = function () {
        $this.find('.invalid-feedback').text('');
        $this.find('#id_login.is-invalid').removeClass('is-invalid');
        $this.find('#id_password.is-invalid').removeClass('is-invalid');
    };

    clearError();
    $loader.removeClass('d-none');

    grecaptcha.ready(function() {
        grecaptcha.execute('6LdiOUMoAAAAADn0sXowEnEbPJpt-YU_AmZAehdx', {action: 'submit'}).then(function(token) {

            $('#grecaptcha_token').val(token)
            var redirectOnSuccess = $modal.data('redirect');
            var showError = function (text) {
                setTimeout(function () {
                    $this.find('#id_login').addClass('is-invalid');
                    $this.find('#id_password').addClass('is-invalid');
                    $this.find('.input-group button').addClass('btn-invalid');
                    $loader.addClass('d-none');
                    $this.find('.invalid-feedback').text(text).addClass('d-block');
                }, 1000);
            };


            $.ajax({
                url: $this.attr('action'),
                type: 'POST',
                data: $this.serialize(),
                dataType: 'json'
            }).done(function (data, textStatus, jqXHR) {
                analytics ? analytics("event", "login", {event_label: 'modal'}) : '';
                if (data.result === true) {
                    var $spinner = $loader.find('.spinner');
                    $spinner.fadeOut("slow", function () {
                        $spinner.attr('class', 'far fa-2x fa-thumbs-up text-success');
                        $spinner.fadeIn("slow");
                        setTimeout(function () {
                            if (redirectOnSuccess) {
                                if (typeof redirectOnSuccess === 'string') {
                                    location.replace(redirectOnSuccess)
                                } else if (typeof redirectOnSuccess === 'object') {
                                    redirectOnSuccess.removeClass('needs-login')
                                    redirectOnSuccess.find('[name="_token"]').val(data.token)
                                    redirectOnSuccess.submit()
                                    $modal.modal('hide')
                                }
                            } else if (data.intended) {
                                location.replace(data.intended)
                            } else {
                                location.reload();
                            }
                        }, 500);
                    });
                } else {
                    showError('Errore, verifica le credenziali e riprova.');
                }
            }).fail(function (qXHR, textStatus, errorThrown) {

                showError('Errore, verifica le credenziali e riprova.');
            });
        })
    });
});

$('.form-signup').submit(function (e) {
    e.preventDefault();

    var $this = $(this);
    var $modal = $('#access-modal');
    var $loader = $modal.find('.modal-loader');
    var redirectOnSuccess = $modal.data('redirect');
    var showErrors = function (errors) {
        setTimeout(function () {
            $.each(errors, function (field, errors) {
                var input = $this.find('[name=' + field + ']');
                input.addClass('is-invalid');

                var feedback = input.next('.invalid-feedback');

                if (feedback.length <= 0) {
                    feedback = $('.' + field + '-invalid-feedback');
                }
                feedback.append(
                    $.map(errors, function (error) {
                        return $('<span class="d-inline-block"></span>"').text(error);
                    })
                );
            });
            $loader.addClass('d-none');
        }, 1000);
    };
    var clearError = function () {
        $this.find('.invalid-feedback').text('');
        $this.find('.is-invalid').removeClass('is-invalid');
    };

    clearError();
    $loader.removeClass('d-none');

    $.ajax({
        url: $this.attr('action'),
        type: 'POST',
        data: $this.serialize(),
        dataType: 'json'
    }).done(function (data, textStatus, jqXHR) {
        analytics ? analytics("event", "sign_up", {event_label: "modal"}) : ''

        var $spinner = $loader.find('.spinner');
        $spinner.fadeOut("slow", function () {
            $spinner.attr('class', 'far fa-2x fa-thumbs-up text-success');
            $spinner.fadeIn("slow");
            setTimeout(function () {
                console.log('ok', redirectOnSuccess, data)
                if (redirectOnSuccess) {
                    if (typeof redirectOnSuccess === 'string') {
                        location.replace(redirectOnSuccess)
                    } else if (typeof redirectOnSuccess === 'object') {
                        redirectOnSuccess.removeClass('needs-login')
                        redirectOnSuccess.find('[name="_token"]').val(data.token)
                        redirectOnSuccess.submit()
                        $modal.modal('hide')
                    }
                } else if (data.intended) {
                    location.replace(data.intended)
                }  else {
                    location.reload();
                }
            }, 500);
        });
    }).fail(function (qXHR, textStatus, errorThrown) {
        if (typeof qXHR.responseJSON == 'undefined') {
            showErrors({
                email: ['È stato riscontrato un problema, riprova.']
            });
        }
        showErrors(qXHR.responseJSON.errors);
    });
});

$('.accordion').on('show.bs.collapse hide.bs.collapse', function (e) {
    $(e.target).prev().find("i.fa-inverse").toggleClass('fas fa-plus fas fa-minus');
});

$.circleProgress.defaults.startAngle = -(Math.PI / 2);
$.circleProgress.defaults.fill = '#3399D8';
$.circleProgress.defaults.lineCap = 'round';

$('.circle-progress').circleProgress()

$('a.logout-link').on('click', function (e) {
    e.preventDefault();
    $.post($(this).attr('href')).done(function () {
        location.reload()
    });
});

$('.remote-search').each(function () {
    const $this = $(this)
    const {url} = $this.data()
    const queryKey = $this.attr('name').trim()
    const section = $this.data('section') ? $this.data('section') : 'global'
    const partner = $this.data('partner')

    $this.data('autocomplete', new autoComplete({
        data: {
            src: async () => {
                const queryValue = $this.val()
                const source = await fetch(`${url}?${queryKey}=${queryValue}&s=${section}&p=${partner}`)
                return await source.json()
            },
            cache: false,
            key: ['text']
        },
        highlight: false,
        searchEngine: "loose",
        debounce: 300,
        threshold: 3,
        maxResults: 5,
        observer: false,
        selector: `#${$this.attr('id')}`,
        trigger: {
            event: ["input"]
        },
        resultsList: {
            destination: `#${$this.attr('id')}-results`,
            position: 'afterbegin'
        },
        resultItem: {
            content: (data, source) => {
                source.innerHTML = data.value.html
            },
        },
        noResults: (dataFeedback, generateList) => {
            const autoCompleteJS = $this.data('autocomplete')
            // Generate autoComplete List
            generateList(autoCompleteJS, dataFeedback, dataFeedback.results);
            // No Results List Item
            const result = document.createElement("li");
            result.setAttribute("class", "no_result");
            result.setAttribute("tabindex", "1");
            result.innerHTML = `<span style="display: flex; align-items: center; font-weight: 100; color: rgba(0,0,0,.6);">Nessun risultato con "${dataFeedback.query}"</span>`;
            document.querySelector(`#${autoCompleteJS.resultsList.idName}`).appendChild(result);
        }
    }))
})
    .on('keydown', function (evt) {
        const keyCode = evt.keyCode || evt.which;
        if (keyCode === 13) {
            const selected = $(this).data('selected')
            if (selected) {
                location.href = $('#' + $(this).attr('aria-activedescendant')).find('a').attr('href')
            } else {
                $(this).closest('form').submit()
                return false
            }
        }
    })
    .on('input', function (event) {
        let needle = $(this).val().trim()

        if (needle.length >= 3) {
            $(this).parents('.dropdown-menu').addClass('searching');
            $(this).prevAll('.btn').find('i').removeClass('fa-search').addClass('fa-spinner fa-pulse');
        } else {
            $(this).parents('.dropdown-menu').removeClass('searching');
        }
    })
    .on('results', function (event) {
        $(this).prevAll('.btn').find('i').removeClass('fa-spinner fa-pulse').addClass('fa-search');
    })
    .on('navigation', function (event) {
        $(this).data('selected', event.detail.selection)
    })
    .on('click', function (event) {
        if ($(this).attr('data-direct_search')) {
            $(this).val('')
        }
    })

/* show file value after file select */
$('.custom-file-input').on('change', function (e) {
    $(e.target).siblings('label').text(e.target.files[0].name);
});

/* display selected stars */
$('.rating-input input').change(function () {
    const $radio = $(this)
    const $label = $radio.closest('label')
    $label.siblings('.selected').removeClass('selected')
    $label.addClass('selected')
    const $form = $radio.closest('form')
    if (!$form.length) {
        $('#review-modal')
            // search the relative input
            .find('input[name=rating][value="' + $radio.val() + '"]')
            // set as checked
            .prop("checked", true)
            // raise the change event
            .trigger("change")
    }
})
$('.rating-input[data-target]').on('click', 'label', function () {
    const $ratingInput = $(this).closest('.rating-input')
    $($ratingInput.data('target')).modal('show')
})

// send form for discussion reply
$(document).on('submit', 'form.discussion-form', function (e) {
    e.preventDefault()
    const $form = $(this)

    $.post($form.attr('action'), $form.serialize())
        .done(response => {
            const $panel = $('#discussions-panel')
            let msg = "Grazie per averci mandato " + (response.parent_id ? 'il tuo Commento' : 'la tua Domanda') + ".";
            $form.collapse('hide');
            $panel.data('loaded', false)
            loadLazyPanelContent($panel, $panel.data('url'), true, function () {
                $panel.prepend($('[data-result="' + $form.attr('id') + '"]').removeClass('alert-danger').addClass('alert alert-success').html(msg))
                const $discussion = $('#discussion-' + (response.main_discussion_id || response.id))
                $discussion.collapse('show')
                $('#player-sidebar-content').animate({scrollTop: $discussion.position().top})
            })
        })
        .fail(response => {
            let msg = "Sono stati riscontrati degli errori";
            if (response && response.responseJSON && response.responseJSON.errors) {
                msg += ': <br>' + flatten(toArray(response.responseJSON.errors)).join('<br>');
            } else {
                msg += '. Riprova.'
            }
            $('[data-result="' + $form.attr('id') + '"]').addClass('alert alert-danger').html(msg);
        })
})

$(document).on('submit', 'form#discussion-search', function (e) {
    e.preventDefault()
    $('#discussions-panel').data('loaded', false)
    loadLazyPanelContent($('#discussions-panel'), [
        $(this).attr('action'),
        // filtro tutti i campi con valore
        $(this).find(':input').filter(function (index, element) {
            return $(element).val() != '';
        }).serialize()
    ].join('?'))
}).on('search', 'form#discussion-search [type=search]', function (e) {
    if (e.target.value === '') {
        e.preventDefault()
        $(this).closest('form').trigger('submit')
    }
})

// open automatically a modal when document is loaded
$('[data-automodal]').each(function () {
    $($(this).data('automodal')).modal('show')
})

$('#formid').on('keyup keypress', function(e) {
    var keyCode = e.keyCode || e.which;
    if (keyCode === 13) {
        e.preventDefault();
        return false;
    }
});

$(document).on('keyup keypress', '[data-enter-action="prevent"]', function(e) {
    var keyCode = e.keyCode || e.which;
    if (keyCode === 13) {
        e.preventDefault();
        return false;
    }
})

// protect form from double-submit
$(document).on('submit', 'form.double-submit-prevent', function (e) {
    if (!$(this).data('submitted')) {
        $(this)
            .data('submitted', true)
            .find('button')
            .prop('disabled', true)

        setTimeout(function () {
            $(this)
                .data('submitted', false)
                .find('button')
                .prop('disabled', false)
        }.bind(this), 7500)
    } else {
        e.preventDefault()
    }
})

$(document).on('click', '*[data-toggle="password-hider"]', function (e) {
    e.preventDefault()
    const $this = $(this)
    const passwordFieldId = $this.data('input')
    const passwordField = passwordFieldId ? $(passwordFieldId) : $this.siblings('input[type=password]').get(0)

    if (passwordField.attr('type') === 'password') {
        passwordField.attr('type', 'text');
    } else {
        passwordField.attr('type', 'password');
    }

    $this.find('i').toggleClass('fa-eye fa-eye-slash')
});


$(() => {
    new Readmore('.readmore', {
        speed: 200,
        afterToggle: (trigger, element, expanded) => {
            if (!expanded) {
                const $target = $($(element).data('scroll-to') || element)
                $('html, body').animate({scrollTop: $target.offset().top - 60}, {duration: 100})
            }
            $(element).toggleClass('expanded', expanded)
        },
        blockProcessed: (element, expandible) => {
            $(element).toggleClass('not-expandible', !expandible)
        },
        moreLink: '<a href="#" class="readmore--link readmore--more">Mostra altro <i class="fas fa-chevron-down text-gray ms-1"></i></a>',
        lessLink: '<a href="#" class="readmore--link readmore--less">Mostra meno <i class="fas fa-chevron-up text-gray ms-1"></i></a>'
    });
})

$(function () {
    const $courseAppBanner = $('#course-app-banner')
    const cookie = Cookies.get('hide-app-banner')
    if (!cookie) {
        $courseAppBanner.on('click', '.btn-close', function () {
            Cookies.set('hide-app-banner', (new Date()).getTime(), {expires: 7})
            $courseAppBanner.removeClass('show')
        }).addClass('show')
    }
})

$(function () {
    $(document).on('click', "#complete-payment-button", function () {
        $('#payment-form').submit()
    })
})

$(function () {
    $(document).on('click', "#membership-button-access", function (e) {
        analytics ? analytics('event', "MembershipButtonClicked") : '';
    })
})

$(function () {
    $(this).on("submit", "#search-form", function (e) {
        const needle = document.forms["search-form"]["q"].value;
        if (needle.length < 3) {
            return false;
        }
    })

    $(this).on("submit", "#search-catalog", function (e) {

        const needle = document.forms["search-catalog"]["q"].value;
        if (needle.length < 3) {
            return false;
        }
    })
})

$(function () {

    $(document).on('click', '#gift-alert .btn-close', function () {
        $('#gift-alert').hide()
    })

    $(document).on('submit', '#gift-form', function (e) {
        e.preventDefault();
        const $this = $(this);
        const action = $this.attr('action');
        const giftEmail = $this.find("input[name='gift_email']").val()
        const giftSenderMessage = $this.find("textarea[name='gift_sender_message']").val()
        const giftScheduledAt = $this.find("input[name='gift_scheduled_at']").val()
        const orderId = $this.find("input[name='order_id']").val()
        const submitButton = $('#gift-submit');
        const alert = $('#gift-alert')

        submitButton.html("<span class='text-white'>Sto regalando</span> <i class='fas fa-circle-notch fa-spin text-white'></i>")
        submitButton.attr('disabled', true)

        $.ajax({
            url: action,
            data: {order_id: orderId, gift_sender_message: giftSenderMessage, gift_email: giftEmail, gift_scheduled_at: giftScheduledAt},
            method: 'POST',
            xhrFields: {
                withCredentials: true
            }
        }).done(function (response, status, xhr) {
            if (response && response.success) {
                const redirectUrl = $this.data('redirect');

                alert.addClass('bg-success')
                alert.find('div.toast-body').html("Regalo avvenuto con successo, a breve sarà inviata un'email al destinatario.")
                alert.show()
                submitButton.hide()

                if(redirectUrl) {
                    window.location = redirectUrl;
                } else {
                    window.location.reload();
                }
            }
        }).fail(function (error) {
            submitButton.html('<i class="fa-solid fa-gift"></i> Regala')
            submitButton.attr('disabled', false)
            alert.addClass('bg-danger')
            alert.find('div.toast-body').html("Qualcosa è andato storto, riprova tra qualche minuto o contatta l'assistenza")
            alert.show()
        })
    })

    $(document).on('click', '.gift-modal-button', function () {
        const $giftModal = $('#gift-modal');
        let giftModal = new window.Modal($giftModal)
        const $this = $(this);
        const orderId = $this.data('order_id');

        $.ajax({
            url: '/gifts/popup',
            data: {order_id: orderId},
            method: 'POST',
            xhrFields: {
                withCredentials: true
            }
        }).done(function (response, status, xhr) {
            if (response && response.success) {
                $giftModal.find('.modal-body').html(response.data.html)
                giftModal.show()
            }
        })
    })
})


$(function () {
    const banner = $('#corsi-banner');
    const pageName = banner.data('banner_page_name')
    const identifierFilter = banner.data('banner_identifier_filter')
    const navbar = $("#main-navbar")
    if (!pageName) return;

    $.ajax({
        url: '/api/banners',
        data: {page_name: pageName, identifier_filter: identifierFilter},
        method: 'POST',
        xhrFields: {
            withCredentials: true
        }
    }).done(function (response, status, xhr) {
        banner.html(response.html)
        banner.toggleClass('hide')

        if (navbar.css('position') === 'absolute') {
            navbar.css('top', banner.height() + 10);
            navbar.css('padding-top', 0);

            $(document).scroll(function (e) {
                if ($(document).scrollTop() > banner.height()) {
                    navbar.css('top', 0);
                    navbar.css('padding-top', "4px");
                } else {
                    navbar.css('top', banner.height() + 10);
                    navbar.css('padding-top', 0);
                }
            })
        }
    }).fail(function (error) {
    })
})

function courseStickyManagement() {
    const $window = $(window)
    const $courseStickyButton = $("#course-price-banner")

    $window.on('scroll', function () {
        const scroll = $window.scrollTop()

        if ($courseStickyButton.hasClass('d-sm-none')) {
            return;
        }

        if (scroll > 500) {
            $courseStickyButton.removeClass('d-none').addClass('d-sm-none')
        }
    })
}
